import styled from "@emotion/styled";
import { ExButton, useResizeObserver } from "@energyx-dev/energyx-ui";
import { DEVICE } from "constants/device";
import { useLocation, useNavigate } from "react-router-dom";
import { returnCompleteCnt } from "utils/returnCompleteCnt";

export const LastStage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const device = useResizeObserver();

  const lastPart = location.pathname.slice(location.pathname.lastIndexOf("/") + 1);
  const completeCnt = returnCompleteCnt(lastPart);

  return (
    completeCnt && (
      <Section isDesktop={device === DEVICE.DESKTOP}>
        <article className="container">
          <>
            <Content>
              <span className="xicon-">{completeCnt.icon}</span>
              <h2>{completeCnt.title}</h2>
              <p>{completeCnt.caption}</p>
            </Content>
            {completeCnt.label && (
              <ExButton
                size={device === DEVICE.DESKTOP ? "xLarge" : "large"}
                variant="contained"
                label={completeCnt.label}
                width={device === DEVICE.DESKTOP ? 448 : undefined}
                onClick={() => completeCnt.path && navigate(completeCnt.path)}
              />
            )}
          </>
        </article>
      </Section>
    )
  );
};

const Section = styled.section<{ isDesktop: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 80px 0;
  height: ${({ isDesktop }) => (isDesktop ? "700px" : "488px")};

  article {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 64px;
  }

  ${({ theme }) => theme.breakpoints.down("DESKTOP")} {
    padding: 24px 16px 40px 16px;

    article {
      gap: 24px;

      > div:last-of-type {
        width: 100%;
      }
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;

  > span {
    font-size: 136px;
    color: ${({ theme }) => theme.color.primary[60]};
  }

  > h2 {
    ${({ theme }) => theme.font.H2};
    color: ${({ theme }) => theme.color.black};
  }

  > p {
    ${({ theme }) => theme.font.Body1};
    color: ${({ theme }) => theme.color.mono[60]};
    white-space: pre-wrap;
  }

  ${({ theme }) => theme.breakpoints.down("DESKTOP")} {
    > span {
      font-size: 80px;
      color: ${({ theme }) => theme.color.primary[60]};
    }

    > h2 {
      ${({ theme }) => theme.font.Body3_h};
      color: ${({ theme }) => theme.color.black};
    }

    > p {
      ${({ theme }) => theme.font.Subtitle2};
      color: ${({ theme }) => theme.color.mono[60]};
      white-space: pre-wrap;
    }
  }
`;
